import { render, staticRenderFns } from "./MergiLaSigur.vue?vue&type=template&id=ef4d87cc&scoped=true&"
import script from "./MergiLaSigur.ts?vue&type=script&lang=ts&"
export * from "./MergiLaSigur.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d87cc",
  null
  
)

export default component.exports